'use client'

import { AppLink } from '@/shared/lib/router'

import { authInputClassName, authSecondaryClassName } from '../../constants/styles'
import { AuthShell } from '../AuthShell'
import { ForgotPasswordButton } from '../ForgotPassword/Button'
import { ForgotPasswordFields } from '../ForgotPassword/Fields'
import { ForgotPasswordForm } from '../ForgotPassword/Form'

export function ForgotPasswordPage() {
  return (
    <AuthShell
      title="Esqueceu sua senha?"
      subtitle="Enviaremos um código para você redefini-la"
    >
      <ForgotPasswordForm className="flex flex-col gap-4">
        <ForgotPasswordFields inputClassName={authInputClassName} />
        <ForgotPasswordButton>Resetar Senha</ForgotPasswordButton>
        <AppLink href="/sign-in" className={authSecondaryClassName}>
          Cancelar
        </AppLink>
      </ForgotPasswordForm>
    </AuthShell>
  )
}
